import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import { Input } from "@frui.ts/bootstrap";

export const CardParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("cardParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translateAttribute("outgoingPayGatePayment.cardNumber")}*</Form.Label>
          <Input
            target={vm.card}
            property="cardNumber"
            placeholder={vm.translateAttribute("outgoingPayGatePayment.cardNumber")}
            disabled={!vm.canEditCard}
          />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("cardParameters.authCode")}*</Form.Label>
          <Input
            target={vm.card}
            property="authCode"
            placeholder={vm.translate("cardParameters.authCode")}
            disabled={!vm.canEditCard}
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translate("cardParameters.arn")}*</Form.Label>
          <Input target={vm.card} property="arn" placeholder={vm.translate("cardParameters.arn")} disabled={!vm.canEditCard} />
        </Form.Group>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("cardParameters.variableSymbol")}*</Form.Label>
          <Input
            target={vm.card}
            property="variableSymbol"
            placeholder={vm.translate("cardParameters.variableSymbol")}
            type="number"
            disabled={!vm.canEditCard}
          />
        </Form.Group>
      </div>
    </div>
  );
});
